import { FunctionComponent } from 'react';

import { createElementId } from '../createElementId/createElementId';

export interface IFunctionComponent<TPropType = {}> extends FunctionComponent<TPropType> {
    displayName: string;
    app?: string;
}

export interface INamespaceConfig {
    COMPONENT_PREFIX: string;
    FEATURE_FLAG_PREFIX: string;
}

export class Namespace {
    protected config: INamespaceConfig;

    public constructor (config: INamespaceConfig) {
        this.config = config;
    }

    public createComponent<TPropType> (displayName: string, renderFn: FunctionComponent<TPropType>): IFunctionComponent<TPropType> {
        const component: IFunctionComponent<TPropType> = renderFn as IFunctionComponent<TPropType>;

        component.displayName = this.createDisplayName(displayName);
        component.app = this.config.COMPONENT_PREFIX;

        return component;
    }

    public createDisplayName (name: string): string {
        try {
            return createElementId(this.config.COMPONENT_PREFIX, name);
        } catch {
            // Need to throw a different error to make it more clear what happened
            throw new Error(`Display name created using "${name}" which is non-standard. Name must be UpperCamelCase.`);
        }
    }
}
